// Ordered, clinician-configurable target-time progression for the clock games.
// Random target times are too hard for these patients, so the correct answer
// follows a fixed, gradually-harder sequence instead. Distractor clocks stay
// randomized in the game forms.

// Sensible default: whole hours first, then half-hours, then quarter-hours.
export const DEFAULT_TIME_PROGRESSION = [
  { hours: 3, minutes: 0 },
  { hours: 4, minutes: 0 },
  { hours: 3, minutes: 30 },
  { hours: 4, minutes: 30 },
  { hours: 3, minutes: 45 },
  { hours: 4, minutes: 45 },
];

const isValidStep = (s) =>
  s &&
  Number.isFinite(s.hours) &&
  Number.isFinite(s.minutes) &&
  s.hours >= 0 &&
  s.hours <= 23 &&
  s.minutes >= 0 &&
  s.minutes <= 59;

// Read a progression from per-patient game settings (#34), falling back to the
// default when nothing valid is configured.
export const progressionFromSettings = (settings) => {
  const raw = settings && settings.time_progression;
  if (Array.isArray(raw) && raw.length > 0 && raw.every(isValidStep)) {
    return raw;
  }
  return DEFAULT_TIME_PROGRESSION;
};

// The target time (a Date today at the step's hours:minutes) for a zero-based
// step, cycling through the progression so play can continue past the last step.
export const targetTimeForStep = (progression, step) => {
  const list =
    Array.isArray(progression) && progression.length
      ? progression
      : DEFAULT_TIME_PROGRESSION;
  const index = ((step % list.length) + list.length) % list.length;
  const entry = list[index];
  const date = new Date();
  date.setHours(entry.hours, entry.minutes, 0, 0);
  return date;
};
